import * as React from "react";
const SvgCheck = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 21,
	height: 22,
	viewBox: "0 0 21 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M7.69557 14.3906L4.04682 10.7418L2.80432 11.9756L7.69557 16.8668L18.1956 6.36681L16.9618 5.13306L7.69557 14.3906Z",
	fill: "currentColor"
}));
export default SvgCheck;
